// AWS Regions
export const REGIONS = [
  { region: 'us-east-1', name: 'US East (N. Virginia)' },
  { region: 'us-east-2', name: 'US East (Ohio)' },
  { region: 'us-west-1', name: 'US West (N. California)' },
  { region: 'us-west-2', name: 'US West (Oregon)' },
  { region: 'af-south-1', name: 'Africa (Cape Town)' },
  { region: 'ap-east-1', name: 'Asia Pacific (Hong Kong)' },
  { region: 'ap-south-1', name: 'Asia Pacific (Mumbai)' },
  { region: 'ap-northeast-3', name: 'Asia Pacific (Osaka)' },
  { region: 'ap-northeast-2', name: 'Asia Pacific (Seoul)' },
  { region: 'ap-southeast-1', name: 'Asia Pacific (Singapore)' },
  { region: 'ap-southeast-2', name: 'Asia Pacific (Sydney)' },
  { region: 'ap-northeast-1', name: 'Asia Pacific (Tokyo)' },
  { region: 'ca-central-1', name: 'Canada (Central)' },
  { region: 'eu-central-1', name: 'Europe (Frankfurt)' },
  { region: 'eu-west-1', name: 'Europe (Ireland)' },
  { region: 'eu-west-2', name: 'Europe (London)' },
  { region: 'eu-south-1', name: 'Europe (Milan)' },
  { region: 'eu-west-3', name: 'Europe (Paris)' },
  { region: 'eu-north-1', name: 'Europe (Stockholm)' },
  { region: 'me-south-1', name: 'Middle East (Bahrain)' },
  { region: 'sa-east-1', name: 'South America (Sao Paulo)' },
];

// Operating System Types
export const OS_TYPES = [
  { os: 'linux', label: 'Linux' },
  { os: 'windows', label: 'Windows' },
];

// Default EC2 Instance Types (2026 - latest generation)
export const INITIAL_INSTANCE_TYPES = [
  // General Purpose - Graviton (ARM, best price/performance)
  { ec2_type: 'm7g.large' },
  { ec2_type: 'm7g.xlarge' },
  { ec2_type: 'm8g.large' },
  // General Purpose - Intel/AMD
  { ec2_type: 'm7i.large' },
  { ec2_type: 'm7a.large' },
  // Compute Optimized - Graviton
  { ec2_type: 'c7g.large' },
  { ec2_type: 'c7g.xlarge' },
  { ec2_type: 'c8g.large' },
  // Compute Optimized - Intel/AMD
  { ec2_type: 'c7i.large' },
  { ec2_type: 'c7a.large' },
  // Memory Optimized - Graviton
  { ec2_type: 'r7g.large' },
  { ec2_type: 'r8g.large' },
  // Memory Optimized - Intel/AMD
  { ec2_type: 'r7i.large' },
  { ec2_type: 'r7a.large' },
  // Burstable - Graviton (cost-effective)
  { ec2_type: 't4g.micro' },
  { ec2_type: 't4g.small' },
  { ec2_type: 't4g.medium' },
  { ec2_type: 't4g.large' },
];

// EC2 Instance Families (2026 - current generation)
export const INSTANCE_FAMILIES = [
  // Graviton (ARM) - Best price/performance
  "m7g", "m8g",
  "c7g", "c8g",
  "r7g", "r8g",
  "t4g",
  // Intel
  "m7i", "m7i-flex",
  "c7i", "c7i-flex",
  "r7i",
  // AMD
  "m7a",
  "c7a",
  "r7a",
  // Previous gen (still common)
  "m6i", "m6a", "m6g",
  "c6i", "c6a", "c6g",
  "r6i", "r6a", "r6g",
  "t3", "t3a",
];

// Normalization Factors for EC2 Instance Sizes
export const NORMALIZATION_FACTORS = {
  nano: 0.25,
  micro: 0.5,
  small: 1,
  medium: 2,
  large: 4,
  xlarge: 8,
  "2xlarge": 16,
  "3xlarge": 24,
  "4xlarge": 32,
  "6xlarge": 48,
  "8xlarge": 64,
  "9xlarge": 72,
  "10xlarge": 80,
  "12xlarge": 96,
  "16xlarge": 128,
  "18xlarge": 144,
  "24xlarge": 192,
  "32xlarge": 256,
  "56xlarge": 448,
  "112xlarge": 896,
};

// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://wzstkt5ta4.execute-api.us-east-1.amazonaws.com/dev-v2',
  INSTANCES_URL: 'https://u27tg888eb.execute-api.us-east-1.amazonaws.com/dev',
};

// Error Messages
export const ERROR_MESSAGES = {
  GENERIC: 'Oops, something went wrong. Try again.',
  NETWORK: 'Network error. Please check your connection.',
  NO_DATA: 'No data available for this selection.',
};
